"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DepositBundleConditionRule = exports.TimeAfterAutopayEnabledDays = exports.AutopayConditionRule = exports.ConditionTypes = void 0;
var ConditionTypes;
(function (ConditionTypes) {
    ConditionTypes["autopayConditions"] = "autopayConditions";
    ConditionTypes["depositBundleConditions"] = "depositBundleConditions";
})(ConditionTypes || (exports.ConditionTypes = ConditionTypes = {}));
var AutopayConditionRule;
(function (AutopayConditionRule) {
    AutopayConditionRule["ENABLED"] = "ENABLED";
    AutopayConditionRule["CATEGORY"] = "CATEGORY";
    AutopayConditionRule["TIME_AFTER_ENABLED"] = "TIME_AFTER_ENABLED";
})(AutopayConditionRule || (exports.AutopayConditionRule = AutopayConditionRule = {}));
var TimeAfterAutopayEnabledDays;
(function (TimeAfterAutopayEnabledDays) {
    TimeAfterAutopayEnabledDays[TimeAfterAutopayEnabledDays["FIVE"] = 5] = "FIVE";
})(TimeAfterAutopayEnabledDays || (exports.TimeAfterAutopayEnabledDays = TimeAfterAutopayEnabledDays = {}));
var DepositBundleConditionRule;
(function (DepositBundleConditionRule) {
    DepositBundleConditionRule["CASHBACK_BOOST_DEPOSIT_BUNDLE_ENROLLMENT_ACTIVE"] = "CASHBACK_BOOST_DEPOSIT_BUNDLE_ENROLLMENT_ACTIVE";
})(DepositBundleConditionRule || (exports.DepositBundleConditionRule = DepositBundleConditionRule = {}));
